import React, { useState } from "react";

// images and icons
import BannerImage from "assets/breakfast-event/png-jpg/banner.png";
import BannerImageBottom from "assets/breakfast-event/png-jpg/banner-image-bottom.png";
import BannerImageTop from "assets/breakfast-event/png-jpg/banner-image-top.png";
import AnchorRightIcon from "assets/breakfast-event/svgs/anchor-right.svg";
import BecomePartner from "assets/breakfast-event/png-jpg/become-partner.png";

// slider
import Slider from "react-infinite-logo-slider";

// Modal
import PartnerWaitlistModal from "./components/PartnerWaitlistModal";
// Translations
import { useTranslation } from "react-i18next";

const Home = () => {
  // Translations
  const { t } = useTranslation("event");

  // Hook state
  const [isOpen, setIsOpen] = useState(false);

  // Functions
  const handleRegister = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLScNFWGjiRVGtoU6NNRG4iw1ZRQ2i_dRHUkI8XfNev4F__aKcg/viewform?usp=publish-editor",
      "_blank",
    );
  };
  return (
    <div id="home">
      <div
        className="!w-full h-[1050px] md:h-[85vh] lg:h-[731px] bg-cover bg-center scroll-mt-[90px]"
        style={{ backgroundImage: `url(${BannerImage})` }}
      >
        <div className="w-[92%] mx-auto py-[6rem] xl:pt-[13rem] xl:pb-0 flex justify-between flex-col lg:flex-row text-white md:relatve">
          <div className="w-full lg:max-w-[500px] xl:max-w-[700px]">
            <h3 className="text-[28px] md:text-[56px] font-euclidBold">
              {t("homeSection.title")}
            </h3>
            <p className="text-xl md:text-[24px] font-euclidSemibold">
              {t("homeSection.subTitle")}
            </p>
            <p className="text-lg font-euclid font-normal mt-4 font-euclidRegular">
              {t("homeSection.description")}
            </p>
            <div className="flex items-center flex-col md:flex-row gap-5 md:gap-3 mt-5">
              <div className="flex items-center">
                <button
                  className="bg-[#202D66] font-euclid text-white text-base xl:text-base  font-euclidSemibold h-[48px] px-6 md:px-5 rounded-l-[16px] rounded-r-none"
                  onClick={handleRegister}
                >
                  {t("homeSection.cta")}
                </button>
                <button className="bg-[#AFF7CD] text-white text-base  font-euclidSemibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                  <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                </button>
              </div>

              <div className="h-6 w-px bg-gray-400 hidden md:block"></div>

              <button
                className="border-none outline-none"
                onClick={() => setIsOpen(true)}
              >
                <img
                  src={BecomePartner}
                  alt="BecomePartner"
                  className="!mb-0 w-[200px]"
                />
              </button>
            </div>
          </div>
          <div className="xl:absolute xl:right-[8%] top-30 xl:top-[15%] flex justify-center items-center md:block mt-3 xl:mt-0">
            <img
              src={BannerImageTop}
              alt="BannerImageTop"
              className=" w-[251.65px] md:w-[400px] xl:w-full h-[251.65px] md:h-[400px] xl:h-auto"
            />
            <div className="absolute top-[50rem] md:top-[45%] lg:top-[45%] xl:top-[60%] right-0 md:-right-0 xl:-right-[10%] w-[300px] md:w-[450px] xl:w-[300px] scale-[1]">
              <img
                src={BannerImageBottom}
                alt="BannerImageBottom"
                className="w-[220px] md:w-[350px] xl:w-full h-[220px] md:h-[350px] xl:h-auto"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#D89A53] h-[45px] flex items-center overflow-hidden">
        <div className="w-full overflow-hidden">
          {/* SM */}
          <div className="block md:hidden">
            <Slider
              width="80vw"
              duration={120}
              pauseOnHover={false}
              blurBorders={false}
            >
              {Array(10)
                .fill(t("homeSection.sliderText"))
                .map((item, index) => (
                  <Slider.Slide key={index}>
                    <div className="px-4 flex items-center">
                      <p className="text-[#202D66] text-[14px] font-euclidSemibold">
                        {item}
                      </p>
                    </div>
                  </Slider.Slide>
                ))}
            </Slider>
          </div>

          {/* MD */}
          <div className="hidden md:block xl:hidden">
            <Slider
              width="50vw"
              duration={120}
              pauseOnHover={false}
              blurBorders={false}
            >
              {Array(10)
                .fill(t("homeSection.sliderText"))
                .map((item, index) => (
                  <Slider.Slide key={index}>
                    <div className="px-8 flex items-center">
                      <p className="text-[#202D66] text-[20px] font-euclidSemibold">
                        {item}
                      </p>
                    </div>
                  </Slider.Slide>
                ))}
            </Slider>
          </div>

          {/* XL */}
          <div className="hidden xl:block">
            <Slider
              width="35vw"
              duration={120}
              pauseOnHover={false}
              blurBorders={false}
            >
              {Array(10)
                .fill(t("homeSection.sliderText"))
                .map((item, index) => (
                  <Slider.Slide key={index}>
                    <div className="px-8 flex items-center">
                      <p className="text-[#202D66] text-[20px] font-semibold">
                        {item}
                      </p>
                    </div>
                  </Slider.Slide>
                ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* /* Modal */}
      <PartnerWaitlistModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default Home;
